import {
  useEffect,
  useState,
} from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../common/Icon/Icon';
import { IconKeys } from '../../common/Icon/IconKeys';
import useAutoFocus from '../../../utils/hooks/useAutoFocus';

import S from './SearchInputStyles';

type Props = {
  onSearchClick: (text: string) => void;
};

function SearchInput({
  onSearchClick,
}: Props): JSX.Element {
  const [text, setText] = useState<string>('');
  const navigate = useNavigate();
  const inputRef = useAutoFocus();

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setText(e.target.value);
  };

  const handleSearchClick = (): void => {
    onSearchClick(text);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>): void => {
    if (event.key === 'Enter') {
      handleSearchClick();
    }
    if (event.key === 'Escape') {
      navigate(-1);
    }
  };

  useEffect(() => () => {
    setText('');
    handleSearchClick();
  }, []);

  return (
    <S.Wrapper>
      <div
        className="search-box"
      >
        <button
          className="btn-search"
          type="button"
          onClick={handleSearchClick}
        >
          <Icon iconKey={IconKeys.SEARCH_SMALL} />
        </button>
        <input
          ref={inputRef}
          type="text"
          className="input-search"
          placeholder="Search here..."
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
        />
        <button
          className="btn-search-history"
          type="button"
          onClick={() => {}}
        >
          <Icon iconKey={IconKeys.CLOCK_HISTORY} />
        </button>
      </div>
    </S.Wrapper>
  );
}

export default SearchInput;
